import { Button, Divider, Input, Modal, Radio } from "antd";
import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { CONFIG } from "../environment";
import { allowOnlyNumbers } from "../services/common.service";
import { useSelector } from "react-redux";
import {
  loginVerifyDetailsSelector,
  profileDetailsSelector,
} from "../store/selectors/app.selector";
import { useTranslation } from "react-i18next";
import { ReactComponent as TickIcon } from "../assests/images/tickIcon.svg";
import { useNavigate } from "react-router";

export default function OTP({
  otp = "",
  setOtp,
  loading = false,
  cancelTransaction,
  onConfirm,
  handleResendOtp,
  bankLogo = "",
  verifyDetails = [],
  successVisible,
  message,
  routingURL,
}) {
  const [seconds, setSeconds] = useState(CONFIG.OTP_TIMER);
  const profileDetails = useSelector(profileDetailsSelector);
  const loginVerifyDetails = useSelector(loginVerifyDetailsSelector);
  const [cancelVisible, setCancelVisible] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [type, setType] = useState("OTP");
  const maxOtpLength =
    type === "MOBILE_TOKEN"
      ? +loginVerifyDetails?.transferOTPLen
      : CONFIG.OTP_LENGTH;

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds <= 0) {
        clearTimeout(interval);

        return false;
      }
      setSeconds(seconds - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      <div className="otp-wrappper">
        {bankLogo && (
          <div align="center" className="mb-4">
            <img src={bankLogo} height={80}  alt="Bank Logo" />
          </div>
        )}
        {loginVerifyDetails?.registeredForTransferOTP === true ? (
          <div style={{ width: 450, margin: "0 auto", fontWeight: 600 }}>
            <Radio.Group
              onChange={(e) => {
                setType(e.target.value);
                setOtp("");
              }}
              defaultValue={type}
            >
              <Radio value={"OTP"}>
                {t("pages.otp.enter_sms_otp", { defaultValue: "Enter SMS OTP" })}
              </Radio>
              <Radio value={"MOBILE_TOKEN"}>
                {t("pages.otp.enterTPIN", { defaultValue: "Enter Secure OTP" })}
              </Radio>
            </Radio.Group>
          </div>
        ) : (
          <div
            style={{
              width: 450,
              margin: "0 auto",
              fontWeight: 600,
              marginBottom: "-18px",
            }}
            className=""
          >
            <p
              className="text-left secondary_txt_color_two"
              align="left"
              style={{ fontSize: "15px" }}
            >
              {t("pages.otp.enterOtp", { defaultValue: "Enter OTP" })}
            </p>
          </div>
        )}
        <div className="d-flex justify-content-start">
          <div style={{ width: 450, margin: "0 auto" }} className="my-3">
            {type === "MOBILE_TOKEN" ? (
              <p
                className="text-left secondary_txt_color_two secure-otp"
                align="left"
                style={{ fontSize: "13px" }}
              >
                {t("pages.otp.tpintitle", {
                  defaultValue:
                    "Please enter the token generated by the Secure OTP App.",
                })}
              </p>
            ) : (
              <p
                className="text-left secondary_txt_color_two"
                align="left"
                style={{ fontSize: "13px" }}
              >
                {t("pages.otp.otpTitle", {
                  defaultValue: "We have sent OTP code to a number end with",
                })}{" "}
                {Object.keys(profileDetails).length > 0 ? (
                  <b style={{ color: "black" }}>
                    XX
                    {profileDetails?.mobileNo?.slice(
                      profileDetails?.mobileNo?.length - 2
                    )}{" "}
                  </b>
                ) : (
                  <b style={{ color: "black" }}>
                    XX
                    {verifyDetails?.mobile !== undefined
                      ? verifyDetails?.mobile?.slice(
                          verifyDetails?.mobile?.length - 2
                        )
                      : verifyDetails?.mobileNo?.slice(
                          verifyDetails?.mobileNo?.length - 2
                        )}{" "}
                  </b>
                )}
                {t("pages.otp.otpSubTitle", {
                  defaultValue:
                    "and your email, Please use that code to verify",
                })}
              </p>
            )}

            <div
              className={maxOtpLength > 4 ? "secure-otpLength mt-4" : "mt-4"}
            >
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={maxOtpLength}
                onPaste={false}
                shouldAutoFocus={false}
                skipDefaultStyles={true}
                inputStyle={{
                  width: 70,
                  height: 70,
                  display: "inline-block",
                  textAlign: "center",
                  borderRadius: "50% !important",
                  marginRight: 15,
                  fontSize:20
                }}
                inputType="password"
                containerStyle={"input-otp-style"}
                renderInput={(props) => (
                  <Input
                    onKeyPress={(e) => {
                      allowOnlyNumbers(e);
                      const keyCode = e.keyCode || e.which;
                      if (otp.length >= maxOtpLength && keyCode !== 8) {
                        e.preventDefault();
                      }
                    }}
                    size="large"
                    {...props}
                  />
                )}
              />
              <p className=" mt-4 d-flex justify-content-between">
                {type === "OTP" && seconds === 0 && (
                  <span
                    onClick={() => {
                      setSeconds(CONFIG.OTP_TIMER);
                      handleResendOtp();
                      setOtp("");
                    }}
                    className="links"
                  >
                    {t("pages.otp.resend_otp", {
                      defaultValue: "Resend OTP",
                    })}
                  </span>
                )}
                {type === "OTP" && seconds > 0 && (
                  <span>
                    {t("pages.otp.resendOtpIn", {
                      defaultValue: "Resend OTP in",
                    })}{" "}
                    <Divider type="vertical" />{" "}
                    <b>
                      {seconds}{" "}
                      {t("pages.otp.secs", {
                        defaultValue: "Secs",
                      })}
                    </b>
                  </span>
                )}
                <p className="secondary-text"> </p>
              </p>
              <div className="d-flex justify-content-between">
                <Button
                  size="large"
                  block
                  className="mt-2 mr-3 primary-btn"
                  type="primary"
                  disabled={otp.length !== maxOtpLength}
                  onClick={() =>
                    onConfirm({
                      otp: otp,
                      enabledTOTP: type === "MOBILE_TOKEN" ? true : false,
                    })
                  }
                >
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </div>
              <Button
                onClick={() => setCancelVisible(true)}
                //onClick={cancelTransaction}
                block
                type="link"
                size="large"
                className="mt-3"
              >
                {t("buttons.cancel_btn", {
                  defaultValue: "Cancel",
                })}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title={t("common.cancal", {
          defaultValue: "Cancel ?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("common.commont_otp_desc", {
            defaultValue:
              "If you cancel this now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            size="large"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            size="large"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              cancelTransaction();
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>
      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center" className="mt-4">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                navigate(routingURL);
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
